import {
  Breakpoints,
  styled,
  Layout,
  Container,
  ContainerHorizontalAlignment,
  ContainerPadding,
  CTA,
  TextAlignment,
  TextAppearance,
  Text
} from '@volkswagen-onehub/components-core';
import { LegalesFormatoLayer, LssiTkmQuestions, LastNavigation, PoliticaPrivacidad } from 'src/components';
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';


const GeneralconfirmacionWrapper = styled.div`
  padding: 72px 0 44px;
  @media all and (min-width: 960px) {
    padding: 86px 0 0;
  }
`;

const WhiteLinkWrapper = styled.span`
  a {
    color: #ffffff;
    font-weight: bold;
  }
`;

export const ConfirmacionTaigo = () => {
  const dispatch = useDispatch();

  const [lssi, setLssi] = useState<string>(null);
  const [tmk, setTmk] = useState<string>(null);
  const [lssiError, setLssiError] = useState<boolean>(false);
  const [tmkError, setTmkError] = useState<boolean>(false);

  useEffect(() => {
    if (lssi) {
      const values = { lssi: lssi };
      dispatch({ type: 'UPDATE_FIELDS', payload: values });
      setLssiError(false);
    }
    if (tmk) {
      const values = { tmk: tmk };
      dispatch({ type: 'UPDATE_FIELDS', payload: values });
      setTmkError(false);
    }
  }, [lssi, tmk]);

  return (
    <GeneralconfirmacionWrapper>
      <Layout
        appearance={{
          [Breakpoints.default]: [
            { name: '.', columns: 2 },
            { name: 'a', columns: 20 },
            { name: '.', columns: 2 },
          ],
          [Breakpoints.b960]: [
            { name: '.', columns: 3 },
            { name: 'a', columns: 18 },
            { name: '.', columns: 3 },
          ],
        }}
        allowOverflowingContent
      >
        <LssiTkmQuestions title={true} />
        <Container
          horizontalAlign={ContainerHorizontalAlignment.flexStart}
        >
          <Text appearance={TextAppearance.copy200} textAlign={TextAlignment.left} staticSize>
          Enviando este formulario, aceptas las{' '}
            <WhiteLinkWrapper >
              <CTA
                tag="a"
                href='https://cdn.volkswagen.es/repository/app/vw-oneform/assets/other/bbll_lanzamiento_taigo_seinfielalocomun.pdf'
                target="_blank"
                emphasis="tertiary"
              >
                Bases Legales
              </CTA>
            </WhiteLinkWrapper>{' '}
            de la promoción.
          </Text>
          <div style={{paddingTop: '20px'}}>
            <PoliticaPrivacidad />
          </div>
        </Container>
        <LastNavigation 
          loadingCopy='Enviando tu respuesta'
          KoTitle='Ups, se nos ha caído el plan'
          KoBody='Por alguna razón no hemos podido enviar este cuestionario.'
        />
        <LegalesFormatoLayer noPadding={false} title={true} promocion={true} showBasesLegales hrefBasesLegales='https://cdn.volkswagen.es/repository/app/vw-oneform/assets/other/bbll_lanzamiento_taigo_seinfielalocomun.pdf'/>
      </Layout>
    </GeneralconfirmacionWrapper>
  );
};
